import {PropertyBase} from "./PropertyBase";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import * as React from "react";
import {observer} from "mobx-react";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import {ReactElement} from "react";

export class DropDownProperty extends PropertyBase{
    public label:string="Field Type";
    public options:{label:string,value:string}[]=[];
    public Tooltip:ReactElement=null;
    private _isMultiple:boolean=false;

    public SetMultiple(multiple:boolean)
    {
        this._isMultiple=multiple;
        return this;
    }

    public AddOption(label:string,value:string)
    {
        this.options.push({
            value:value,
            label:label
        });
        return this;
    }
    public SetTooltip(content:ReactElement)
    {
        this.Tooltip=content;
        return this;
    }

    public SubRenderer(): React.ReactNode {
        return (
            <SearchableSelect isMulti={this._isMultiple} LabelControl={this.GetTooltip(this.Tooltip)} Value={this.GetOptionValue(this.OptionsPropertyName)}  disabled={this.disabled} Label={this.label} onChange={(e:any)=>this.SetOptionValue(this._isMultiple?e.map(x=>x.value):e,this.OptionsPropertyName)} >
                {this.options.map(x=>
                    <option key={x.value} value={x.value}>{x.label}</option>
                )}
            </SearchableSelect>
        )
    }

}